import CartService, { CART_CHANGE_EVENT, CART_EXPIRED_EVENT, CART_EXPIRING_EVENT, type CartChangeDetail, type CartExpiringDetail, WARNING_LEAD_MS } from '../Service/CartService'
import { getElement } from '../Utility/Dom'

const formatRemaining = (ms: number): string => {
  const total = Math.max(0, Math.floor(ms / 1000))
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

class CartExpiringModal {
  private readonly countdownElement: HTMLElement | null
  private readonly dialog: HTMLDialogElement | null
  private readonly extendButton: HTMLElement | null
  private intervalId: null | number = null

  constructor() {
    this.dialog = getElement('cart-expiring-modal') as HTMLDialogElement | null
    this.extendButton = getElement('cart-expiring-extend')
    this.countdownElement = getElement('cart-expiring-countdown')
  }

  init(): void {
    if (this.dialog === null) return
    this.addEvents()
  }

  private addEvents(): void {
    document.addEventListener(CART_EXPIRING_EVENT, (event: Event): void => {
      this.open((event as CustomEvent<CartExpiringDetail>).detail.expiresAt)
    })
    document.addEventListener(CART_EXPIRED_EVENT, (): void => this.close())
    document.addEventListener(CART_CHANGE_EVENT, (event: Event): void => {
      this.handleChange((event as CustomEvent<CartChangeDetail>).detail)
    })

    this.extendButton?.addEventListener('click', (): void => {
      void CartService.extendReservation()
    })
    this.dialog?.addEventListener('cancel', (event: Event): void => event.preventDefault())
  }

  private close(): void {
    this.stopCountdown()
    if (this.dialog?.open === true) this.dialog.close()
  }

  private handleChange(detail: CartChangeDetail): void {
    // Cart emptied or refreshed to a comfortable TTL again → the warning no longer applies.
    if (detail.items.length === 0 || detail.expiresAt - Date.now() > WARNING_LEAD_MS) {
      this.close()
    }
  }

  private open(expiresAt: number): void {
    if (this.dialog === null || this.dialog.open === true) return
    this.dialog.showModal()
    this.startCountdown(expiresAt)
  }

  private startCountdown(expiresAt: number): void {
    this.stopCountdown()
    this.tick(expiresAt)
    this.intervalId = window.setInterval((): void => this.tick(expiresAt), 1000)
  }

  private stopCountdown(): void {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  private tick(expiresAt: number): void {
    if (this.countdownElement !== null) {
      this.countdownElement.textContent = formatRemaining(expiresAt - Date.now())
    }
  }
}

const cartExpiringModal = new CartExpiringModal()
cartExpiringModal.init()
